import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/questions')({
  component: RouteComponent,
  loader: () => ({
    crumb: 'Questions',
  }),
});

function RouteComponent() {
  return <Outlet />;
}
